import { ICustomSectionTemplateResponse } from 'services/templates/section-template/types';
import {
  IContractTemplateTreeItemForm,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { isParagraphCustomSection } from 'utils/components/contract-template/section/customSection.utils';
import { connectTemplateTreeItems } from '../templateQueryItemsConnector';

export const sectionTemplateQueryToForm = (
  section: ICustomSectionTemplateResponse,
  lowestAvailableId?: string
): IContractTemplateTreeItemForm[] => {
  const isParagraphSection = isParagraphCustomSection(section.type);
  const initialValues = isParagraphSection
    ? contractTemplateUtil.paragraph.initialValues
    : contractTemplateUtil.section.initialValues;

  return initialValues([
    {
      id: lowestAvailableId ?? '1',
      content: section.title,
      type: isParagraphSection
        ? TEMPLATE_TYPE.paragraphSection
        : TEMPLATE_TYPE.section,
      children: connectTemplateTreeItems(
        {
          agreements: section.agreements,
          customSections: section.customSections,
          isParagraphContext: isParagraphSection,
        },
        lowestAvailableId ?? '2'
      ),
    },
  ]);
};
